import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ICommonProductOrderModel, IProductModel } from "../models/product.model";
import { TypeIds } from "src/app/inventory/sales-order/constants/constants";

@Injectable({
    providedIn: "root",
})
export class FormToProductModelBuilderService {
    transformFormToProductModel(formGroup: FormGroup): ICommonProductOrderModel {
        const formData = formGroup.getRawValue();
        return {
            products: this.mapProducts(formData?.products ?? []),
            orderSubtotal: formData?.orderBaseSubtotal ?? 0,
            orderBaseSubtotal: formData?.orderBaseSubtotal ?? 0,
            discount: formData?.discountType ?? null,
            discountRate: formData?.discountRate ?? 0,
            discountAmount: formData?.discountAmount ?? 0,
            taxAmount: formData?.taxAmount ?? 0,
            handlingFee: formData?.handlingFeeType ?? null,
            handlingFeeRate: formData?.handlingFeeRate ?? 0,
            handlingFeeAmount: formData?.handlingFeeAmount ?? 0,
            additionalDiscount: formData?.additionalDiscountType ?? null,
            additionalDiscountRate: formData?.additionalDiscountRate ?? 0,
            additionalDiscountAmount: formData?.additionalDiscountAmount ?? 0,
            shippingCharge: formData?.shippingCharge ?? 0,
            totalAmount: formData?.totalAmount ?? 0,
        };
    }

    private mapProducts(productsData: any[]): IProductModel[] {
        return productsData.map((product) => this.mapProduct(product));
    }

    private mapProduct(product: any): IProductModel {
        const productBase: IProductModel = this.createBaseProductModel(product);
        const bundles = this.mapBundles(product.bundleProducts, productBase);
        productBase.bundleDetails = bundles;
        return productBase;
    }

    private createBaseProductModel(product: any): IProductModel {
        return {
            id: product.id ?? 0,
            createdSource: product.createdSource,
            updatedSource: product.updatedSource,
            createdBy: product.createdBy,
            updatedBy: product.updatedBy,
            createdDate: product.createdDate,
            updatedDate: product.updatedDate,
            productId: product.productId ?? 0,
            itemNo: product.itemNo ?? "",
            description: product.description ?? "",
            uomId: product.uomId ?? 0,
            uom: product.unit?.uomDetail ?? null,
            unit: product.unit ?? null,
            qty: product.qty ?? 0,
            totalQuantity: product.totalQuantity ?? 0,
            price: product.price ?? 0,
            totalAmount: product.totalAmount ?? 0,
            taxAmount: product.taxAmount ?? 0,
            totalCostPrice: product.totalCostPrice ?? 0,
            costPrice: product.costPrice ?? 0,
            subTotal: product.subTotal ?? 0,
            baseSubTotal: product.baseSubTotal ?? 0,
            statusId: product.statusId ?? 0,
            warehouseId: product.warehouseId ?? 0,
            bundleDetails: product.bundleProducts ?? [],
            typeId: product.typeId ?? 0,
            discount: product?.discountType ?? null,
            discountRate: product?.discountRate ?? 0,
            discountAmount: product?.discountAmount ?? 0,
            additionalDiscount: product?.additionalDiscountType ?? null,
            additionalDiscountRate: product?.additionalDiscountRate ?? 0,
            additionalDiscountAmount: product?.additionalDiscountAmount ?? 0,
            handlingFee: product?.handlingFeeType ?? null,
            handlingFeeRate: product?.handlingFeeRate ?? 0,
            handlingFeeAmount: product?.handlingFeeAmount ?? 0,
            tax: product?.tax ?? 0,
            subTaxes: product?.typeId == TypeIds.BundleTypeId ? [] : product?.subTaxes ?? [],
        };
    }

    private mapBundles(bundleProducts: any[], productBase: IProductModel): IProductModel[] {
        return (bundleProducts ?? []).map((bundle) => this.mapBundle(bundle, productBase));
    }

    private mapBundle(bundle: any, productBase: IProductModel): IProductModel {
        return {
            ...productBase,
            id: bundle.id ?? 0,
            createdSource: bundle.createdSource,
            updatedSource: bundle.updatedSource,
            createdBy: bundle.createdBy,
            updatedBy: bundle.updatedBy,
            createdDate: bundle.createdDate,
            updatedDate: bundle.updatedDate,
            productId: bundle.productId ?? 0,
            itemNo: bundle.itemNo ?? "",
            description: bundle.description ?? "",
            uomId: bundle.uomId ?? 0,
            uom: bundle.unit?.uomDetail ?? null,
            unit: bundle.unit ?? null,
            qty: bundle.qty ?? 0,
            totalQuantity: bundle.totalQuantity ?? 0,
            price: bundle.price ?? 0,
            totalAmount: bundle.totalAmount ?? 0,
            taxAmount: bundle.taxAmount ?? 0,
            totalCostPrice: bundle.totalCostPrice ?? 0,
            costPrice: bundle.costPrice ?? 0,
            subTotal: bundle.subTotal ?? 0,
            baseSubTotal: bundle.baseSubTotal ?? 0,
            statusId: bundle.statusId ?? 0,
            warehouseId: bundle.warehouseId ?? 0,
            bundleDetails: [],
            typeId: bundle.typeId ?? 0,
            discount: bundle.discountType ?? null,
            discountRate: bundle?.discountRate ?? 0,
            discountAmount: bundle?.discountAmount ?? 0,
            additionalDiscount: bundle?.additionalDiscountType ?? null,
            additionalDiscountRate: bundle?.additionalDiscountRate ?? 0,
            additionalDiscountAmount: bundle?.additionalDiscountAmount ?? 0,
            handlingFee: bundle?.handlingFeeType ?? null,
            handlingFeeRate: bundle?.handlingFeeRate ?? 0,
            handlingFeeAmount: bundle?.handlingFeeAmount ?? 0,
            tax: bundle?.tax ?? 0,
            subTaxes: bundle?.subTaxes ?? [],
        };
    }
}
